import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { aggregateTeamsByBranchId, salesTeamsForCurrentUser } from '../slice'

export function useGetSalesTeamsByBranch(branchId: string) {
  const salesTeams = useSelector(salesTeamsForCurrentUser)

  const filtered = useMemo(
    () => aggregateTeamsByBranchId(branchId, salesTeams),
    [salesTeams, branchId],
  )

  return filtered
}
